import Box from "@mui/material/Box";
import type { ComponentProps } from "react";
import { AdvancedFold } from "../FoldList.tsx";
import ClaudeModelSelect, { useClaudeModels } from "./ClaudeModelSelect.tsx";

/**
 * Where a form picks the Claude model: an "Advanced" fold, the last thing in
 * the form, holding the model dropdown. Folded it reads e.g. "Model: Claude
 * Sonnet 5.5 (default)". It always starts folded; the summary names a pinned
 * model, so a pin is never hidden.
 */
export default function AdvancedModelFold(props: ComponentProps<typeof ClaudeModelSelect>) {
  const { tenantId, value, inherited, defaultLabel = "Default", catalog } = props;
  const { data, nameOf, isLoading } = useClaudeModels(tenantId, catalog);
  const fallsTo = inherited || data?.default_model;
  const summary = value
    ? `Model: ${nameOf(value)}`
    : fallsTo
      ? `Model: ${nameOf(fallsTo)} (${defaultLabel.toLowerCase()})`
      : isLoading
        ? "Model: loading…"
        : `Model: ${defaultLabel.toLowerCase()}`;

  return (
    <AdvancedFold summary={summary}>
      {/* Room for the outlined field's floating label inside the fold. */}
      <Box sx={{ pt: 1 }}>
        <ClaudeModelSelect {...props} />
      </Box>
    </AdvancedFold>
  );
}
